import script from "./menu-multi-panel.vue?vue&type=script&setup=true&lang=ts"
export * from "./menu-multi-panel.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__